<template>
  <div id="root">
    <div style="outline:none" tabindex="-1" role="group">
      <div class="main-container">
        <div class="app-container">
          <div class="main-page-container">
            <div style="outline:none" tabindex="-1" role="group">
              <div class="page-container article-type">
                <Header />
                <div class="page-wrapper bg-layer">
                  <div
                    class="sections-wrapper default-wrapper"
                    style="visibility: inherit; opacity: 1;"
                  >
                    <div class="stores-block">
                      <div class="grid-wrapper centered" style="z-index:10">
                        <h2 class="title-component impressive uppercase mov"
                              :class="{ active: show }">
                          店铺
                        </h2>
                        <div class="fields grid-11 sm-grid-6 mov"
                              :class="{ active: show }">
                          <div class="search-field">
                            <div
                              class="search-container-component sisal with-wen"
                            >
                              <div class="choice">
                                <input type="text" v-model="name" />
                                <div class="wen" @click="search">
                                  <svg
                                    viewBox="0 0 21 20"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style="width: 25px; vertical-align: middle;"
                                  >
                                    <path
                                      d="M12.39493 15.6989c-3.63462 0-6.5915-2.94842-6.5915-6.57256s2.95688-6.57257 6.5915-6.57257c3.63463 0 6.59151 2.94843 6.59151 6.57257 0 3.62414-2.95688 6.57257-6.5915 6.57257m0-14.97164c-4.64456 0-8.42326 3.7678-8.42326 8.39907 0 1.58147.4409 3.06203 1.20611 4.32643L.63636 17.98112l1.29532 1.2916 4.36778-4.35537c1.53518 1.60595 3.7002 2.60806 6.09547 2.60806 4.64456 0 8.42325-3.7678 8.42325-8.39907 0-4.63127-3.7787-8.39907-8.42325-8.39907"
                                      fill="#D3C8BA"
                                      fill-rule="evenodd"
                                    ></path>
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="group">
                            <div
                              class="field grid-12 sm-grid-6 sm-marg-1-right mov"
                              :class="{ active: show }"
                            >
                              <p class="content-component default">地区</p>
                              <div class="select-container-component sisal">
                                <Select v-model="model1" @on-change="GJChange">
                                  <Option
                                    v-for="item in cityList"
                                    :value="item.value"
                                    :key="item.value"
                                    >{{ item.value }}</Option
                                  >
                                </Select>
                              </div>
                            </div>
                            <div class="field grid-12 sm-grid-6 sm-marg-1-left mov"
                              :class="{ active: show }">
                              <p class="content-component default">省市</p>
                              <div class="search-container-component sisal">
                                <Select
                                  v-model="model2"
                                  @on-change="CityChange"
                                >
                                  <Option
                                    v-for="item in cityList1"
                                    :value="item.value"
                                    :key="item.value"
                                    >{{ item.value }}</Option
                                  >
                                </Select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        class="selector grid-wrapper no-padding centered"
                        ref="map"

                      >
                        <div class="listing grid-12 sm-grid-10 mov"
                              :class="{ active: show }">
                          <div class="marg-1-right" @click="changeMap(1)">
                            <p
                              class="content-component default centered uppercase text"
                              :class="[{ 'malta-and-default': mapShow },  {active: show}]"
                            >
                              列表
                            </p>
                          </div>
                          <div @click="changeMap(2)">
                            <p
                              class="content-component default centered uppercase text"
                              :class="[{ 'malta-and-default': !mapShow }, {active: show}]"
                            >
                              地图
                            </p>
                          </div>
                        </div>
                        <div class="listing grid-12 sm-grid-10 text"
                              :class="{ active: show }" v-if="!mapShow">
                          <div>
                            <p
                              class="content-component  centered uppercase"
                              v-for="(item, index) in classify"
                              :key="index"
                              :class="[
                                { default: activeIndex == index },
                                { 'malta-and-default': activeIndex !== index }
                              ]"
                              style="margin: 0 10px"
                              @click="classifyFn(item, index)"
                            >
                              {{ item }}
                            </p>
                          </div>
                        </div>
                        <div class="list-stores-block mov"
                              :class="{ active: show }" v-if="!mapShow">
                          <ul class="grid-wrapper">
                            <li
                              class="item-stores-block grid-12 sm-grid-6 md-grid-4"
                              v-for="(item, index) in list"
                              :key="index"
                            >
                              <div class="item-stores-container">
                                <div
                                  class="item-stores-title"
                                  style="height: 80px;"
                                >
                                  <h2
                                    class="title-component default centered uppercase"
                                  >
                                    {{ item.name }}
                                  </h2>
                                </div>
                                <div class="baseline centered">
                                  <div
                                    class="button-component malta content reset deeper see-on-map underline"
                                  >
                                    <div
                                      class="link-container"
                                      @click="addMap(item)"
                                    >
                                      <p>查看地图</p>
                                      <span class="line-decorator"></span>
                                    </div>
                                  </div>
                                </div>
                                <div style="height: 72px;">
                                  <p
                                    class="content-component default address centered"
                                  >
                                    <span>{{ item.address }}</span
                                    >{{ item.city }}, {{ item.country }}
                                  </p>
                                </div>
                                <p
                                  class="content-component default tel centered"
                                >
                                  电话:
                                  <a :href="'tel:' + item.tel">{{
                                    item.tel
                                  }}</a>
                                </p>
                                <!-- <div
                                  class="button-component content appointment centered deeper underline"
                                >
                                  <div class="link-container">
                                    即刻联系店铺<span
                                      class="line-decorator"
                                    ></span>
                                  </div>
                                </div> -->
                              </div>
                            </li>
                          </ul>
                        </div>
                        <div class="grid-wrapper map-wrapper" v-show="mapShow">
                          <div
                            id="container"
                            style="width:100%; height:83vh"
                          ></div>
                          <div class="map-stores-details" v-if="mapDetails">
                            <div class="map-stores-content-wrapper">
                              <h2 class="title-component default">
                                {{ mapDetail.name }}
                              </h2>
                              <p
                                class="content-component default centered address"
                              >
                                {{ mapDetail.city }} / {{ mapDetail.country }}
                              </p>
                              <p class="content-component default centered">
                                电话:
                                <a :href="'tel:' + mapDetail.tel">{{
                                  mapDetail.tel
                                }}</a>
                              </p>
                              <div
                                class="button-component event-block-itinerary content deeper underline"
                              >
                                <div class="link-container">
                                  <a
                                    href="mailto:visitstore@icicle.com"
                                    target="_blank"
                                    >预约店铺</a
                                  ><span class="line-decorator"></span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Footer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
import { Select, Option } from "view-design";
import "view-design/dist/styles/iview.css";
import coordtransform from "../plugins/coordtransform";
import AMap from "AMap"; // 引入高德地图
export default {
  name: "locator",
  data() {
    return {
      list: [],
      copyList: [],
      activeIndex: 0,
      name: "",
      cityList: [
        {
          value: "中国",
          label: "中国"
        }
      ],
      cityList1: [
        {
          value: "上海",
          label: "上海"
        },
        {
          value: "苏州",
          label: "苏州"
        }
      ],
      model1: "",
      model2: "",
      classify: ["ALL", "直营ICB", "直营23区", "集合店", "OUTLET"],
      mapShow: false,
      map: null,
      mapDetails: false,
      mapDetail: {},
      show: false
    };
  },
  components: {
    Header,
    Footer,
    Select,
    Option
  },
  mounted() {
    this.getDataList();
    this.show = true;
  },
  methods: {
    async getDataList() {
      let _this = this
      let { data } = await axios.get(this.$api + "/Api/Shop_All");
      this.list = data.data;
      this.copyList = JSON.parse(JSON.stringify(data.data));
      let city = Array.from(new Set(this.copyList.map(e => e.city)));
      this.cityList1 = city.map(e => {
        return {
          value: e,
          label: e
        };
      });
      this.map = new AMap.Map("container", {
        resizeEnable: true,
        center: [121.50109, 31.23691],
        zoom: 4
      });
      // 添加一些分布不均的点到地图上,地图上添加三个点标记，作为参照
      this.copyList.forEach(function(marker) {
        let a = new AMap.Marker({
          map: _this.map,
          position: [marker.lng, marker.lat],
          offset: new AMap.Pixel(-13, -30)
        });
        AMap.event.addListener(a, "click", function() {
          _this.openInfo(marker);
        });
        _this.map.setFitView()
      });
    },
    classifyFn(item, index) {
      this.activeIndex = index;
      if (index == 0) {
        this.list = this.copyList;
      } else {
        this.list = this.copyList.filter(e => e.classify == item);
      }
    },
    GJChange(v) {
      this.list = this.copyList.filter(e => e.country == v);
    },
    CityChange(v) {
      this.list = this.copyList.filter(e => e.city == v);
    },
    search() {
      this.list = this.copyList.filter(e => e.name.indexOf(this.name) > -1);
    },
    openInfo(item) {
      if (item) {
        console.log(">>>>>", item);
        //构建信息窗体中显示的内容
        this.mapDetails = true;
        this.mapDetail = item;
      }
    },
    addMap(item) {
      this.map.clearMap();
      this.mapDetails = false;
      let _this = this;
      this.mapShow = true;
      this.map.setZoom(16)
      window.scrollTo(0, this.$refs.map.offsetTop - 100);
      this.map.setCenter(coordtransform.wgs84togcj02(item.lng, item.lat));
      var marker = new AMap.Marker({
        position: coordtransform.wgs84togcj02(item.lng, item.lat) //位置
      });
      this.map.add(marker); //添加到地图
      AMap.event.addListener(marker, "click", function() {
        _this.openInfo(item);
      });
    },
    changeMap(v) {
      this.mapShow = v == 2;
    }
  }
};
</script>

<style scoped>
/deep/.ivu-select-selection {
  z-index: 10;
  border: 1px solid #cdc4b8;
  position: relative;
  padding: 5px 0 6px 20px;
  height: auto !important;
  border-radius: 0;
  text-align: left;
  cursor: pointer;
  background: 0 0;
}
/deep/.ivu-select-item,
/deep/.ivu-select {
  color: rgb(95, 79, 70);
}
/deep/.ivu-select-dropdown {
  background: #f6f4f0;
  color: rgb(95, 79, 70);
}
/deep/.ivu-select-item:hover {
  background: #eeebe5;
}
/deep/.ivu-select-item-selected,
/deep/.ivu-select-item-selected:hover {
  color: rgb(95, 79, 70);
}
/deep/.amap-copyright {
  display: none;
}
.map-stores-details {
  left: 80px;
}
@media (max-width: 769px) {
  .map-wrapper {
    padding: 0;
  }
}
.mov.active {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}
.mov {
  opacity: 0;
  transform: translate(0%, 100%) matrix(1, 0, 0, 1, 0, 0);
  transition: all 1s;
}
.text.active {
  opacity: 1;
  transform: matrix(1, 0, 0, 1, 0, 0);
}
.text {
  opacity: 0;
  transform: translate(0%, 300%) matrix(1, 0, 0, 1, 0, 0);
  transition: all 1s;
}
</style>